export function formatValuta(value: any, afterComma?: number) {
    const num = parseFloat(value);
    if (isNaN(num)) return value;

    return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: afterComma,
        maximumFractionDigits: afterComma
    }).format(num);
}
